import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types"

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({theme, color}) => theme.color[color]};
  border-radius: 2rem;
  color: ${({theme, textColor}) => theme.color[textColor]};
  padding: 2rem;
  box-shadow: ${({theme}) => theme.shadow.default};
`

const Card = ({children, purple, style, ...rest}) => {
  return (
    <StyledCard style={style} color={purple ? "indigo600" : "white"} textColor={purple ? "white" : "black"} {...rest}>
      {children}
    </StyledCard>
  )
}

Card.propTypes = {
  children: PropTypes.node,
  purple: PropTypes.bool,
  style: PropTypes.object,
  rest: PropTypes.any,
}

export default Card
